import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const setting = new AxiosInterceptor();

export default {
  getSingleSetting(key) {
    return setting.get("/settings/" + key);
  },
  getAllSettingPublic(qstr = {}, arr) {
    qstr = fx.urlQueryString(qstr, false);
    let url = qstr ? qstr + "&" : "";
    if (arr) {
      Object.keys(arr).map((va) => {
        url = url + fx.parameterizeArray(va, arr[va]);
      });
    }
    return setting.get("/settings/public?" + url);
  },
  getAllSetting(qstr = {}, arr) {
    if (qstr && Object.keys(qstr).length) {
      qstr = fx.urlQueryString(qstr, false);
    }
    let url = qstr ? qstr + "&" : "";
    if (arr) {
      arr.forEach(va => {
        url = url + "groups[]=" + va + "&";
      });
    }
    return setting.get("/settings?" + url);
  },
  updateAllSetting(data) {
    return setting.put("/settings", { settings: data });
  },
  updateSetting(key, data) {
    return setting.put("/settings/" + key, data);
  },
  getTemplateSetting() {
    return setting.get("/settings?group=template");
  },
  getGeneralSetting() {
    return setting.get("/settings?group=general");
  },
  getProductAddonsSetting() {
    return setting.get("/settings?group=product_add_ons");
  },
  getPopUpSetting(qstr = {}) {
    if (qstr && Object.keys(qstr).length) {
      qstr = fx.urlQueryString(qstr, false);
    }
    let url = qstr ? "&" + qstr : "";
    return setting.get("/settings?group=pop_up" + url);
  },
  updateGeneralSetting(data) {
    return setting.put("/settings/general", { settings: data });
  },
  updateTemplateSetting(data) {
    return setting.put("/settings/subscription_discount", { content: data });
  },
  getTemplateSettingSubs() {
    return setting.get("/settings/subscription_discount");
  },
  getReferralSetting() {
    return setting.get("/settings/referral_feature");
  },
  updateReferralSetting(data) {
    return setting.put("/settings/referral_feature", { content: data });
  },
  getCurrency() {
    return setting.get("/settings/currency");
  },
  uploadCakeImg(inputs) {
    return setting.put("/settings/default_cake_image", inputs);
  },
  getBirthdayWish() {
    return setting.get("/settings/birthday_wish");
  },
  updateBirthdayWish(inputs) {
    return setting.put("/settings/birthday_wish", inputs);
  }
};
